import ApiFactory from '../factories/ApiFactory';
import { serialize, prepAutocompleteData } from '@/services/UtilityService';
import { checkHasPermission, CONSUMERS_BLOCK_PERM, CONSUMERS_UNBLOCK_PERM } from '@/middlewares/permissions';

const customers = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`posweb/v1/customers?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const followUps = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`systemadmin/v1/customers/follow-ups?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const changeFollowUpStatus = (id, status) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`systemadmin/v1/customers/follow-ups/${id}/status/${status}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const blocked = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`systemadmin/v1/users/blacklists?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const unblock = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`systemadmin/v1/users/blacklists?id=${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const autocomplete = (q, labelProp = 'phone', valueProp = 'id') => {
	return new Promise((resolve) => {
		customers(q).then((data) => {
			resolve(prepAutocompleteData(data, labelProp, valueProp));
		});
	});
};

const getAddress = (lat, lng) => {
	// return new Promise((resolve, reject) => {
	// 	ApiFactory.get(
	// 		`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&location_type=ROOFTOP&result_type=street_address&key=${process.env.VUE_APP_GOOGLE_MAP_KEY}`
	// 	).then(
	// 		(res) => {
	// 			let formattedAddress = '';
	// 			if (res && res.data && res.data.results && res.data.results[0]) {
	// 				let result = res.data.results[0];
	// 				if (result && result['formatted_address']) {
	// 					formattedAddress = result['formatted_address'];
	// 				}
	// 			}
	// 			resolve(formattedAddress);
	// 		},
	// 		(error) => reject(error)
	// 	);
	// });
	return new Promise((resolve, reject) => {
		ApiFactory.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`).then(
			({ data }) => {
				resolve(data);
			},
			(error) => reject(error)
		);
	});
};

const getAddresses = (customerId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`posweb/v1/customers/${customerId}/addresses`).then(
			(success) => resolve(success.data.data),
			(error) => reject(error)
		);
	});
};

const createAddress = (customerId, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`posweb/v1/customers/${customerId}/addresses`, payload).then(
			(success) => {
				const address = success.data.data;
				address.label = address.addressStreet;
				address.value = address.id;
				resolve(success.data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateAddress = (customerId, addressData) => {
	delete addressData.cDate;
	delete addressData.mDate;
	let address = {
		...addressData,
		customerAddress: {
			latitude: addressData.latitude,
			longitude: addressData.longitude,
		},
	};
	return new Promise((resolve, reject) => {
		ApiFactory.put(`posweb/v1/customers/${customerId}/addresses/${address.id}`, address).then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

const deleteAddress = (addressId) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`justeat/v2/customers/addresses/${addressId}`).then(
			(success) => resolve(success.data),
			(error) => reject(error)
		);
	});
};

const block = (phone) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`systemadmin/v1/users/blacklists`, { phone }).then(resolve, reject);
	});
};

const details = (phone) => {
	return new Promise((resolve, reject) => {
		const query = serialize({
			phoneLikeFilter: phone,
		});
		ApiFactory.get(`systemadmin/v1/customers?${query}`).then(({ data }) => {
			resolve(data.data[0]);
		}, reject);
	});
};

const comments = (phone) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`justeat/v2/customers/${phone}/comments`).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const addComment = (id, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`justeat/v2/customers/${id}/comments`, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const createFollowUp = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`systemadmin/v1/customers/follow-ups`, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const updateFollowUp = (id, payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`systemadmin/v1/customers/follow-ups/${id}`, payload).then(({ data }) => {
			resolve(data.data);
		}, reject);
	});
};

const changeStatusFollowUp = (id, status) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`systemadmin/v1/customers/follow-ups/${id}/status/${status}`).then(() => {
			resolve();
		}, reject);
	});
};

const canBlockCustomer = () => {
	return checkHasPermission([CONSUMERS_BLOCK_PERM]);
};

const canUnblockCustomer = () => {
	return checkHasPermission([CONSUMERS_UNBLOCK_PERM]);
};

export default {
	customers,
	followUps,
	changeFollowUpStatus,
	blocked,
	unblock,
	autocomplete,
	getAddress,
	getAddresses,
	createAddress,
	updateAddress,
	deleteAddress,
	block,
	details,
	comments,
	addComment,
	createFollowUp,
	updateFollowUp,
	changeStatusFollowUp,
	canBlockCustomer,
	canUnblockCustomer,
};
